import React, { useEffect, useState } from 'react';
import NavigationLink from './NavigationLink';
import { useSelector } from 'react-redux';
import MyAccountDesktopContainer from '../../Containers/MyAccountDesktop.container';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';
import { debounce } from 'lodash-es';

const DEBOUCE_DELAY = 100;

const Navigation = () => {
  const { contentLinks } = useSelector((state) => state.navigation);
  const ecommerceDisabled = useEcommerceDisabled();
  const [activeMegaMenuLink, setActiveMegaMenuLink] = useState(null);

  const debouncedSetActiveMegaMenuLink = debounce(
    (link) => setActiveMegaMenuLink(link),
    DEBOUCE_DELAY
  );

  const onMouseLeaveLink = () => {
    debouncedSetActiveMegaMenuLink(null);
  };

  const onMegaMenuClose = () => setActiveMegaMenuLink(null);

  useEffect(() => {
    document.body.classList.toggle(
      'navigation-megamenu-opened',
      activeMegaMenuLink !== null
    );
  }, [activeMegaMenuLink]);

  return contentLinks?.length > 0 ? (
    <div className="navbar__container">
      <div className="navbar__menu">
        {contentLinks.map((link, index) => (
          <NavigationLink
            key={link.url + link.name + 'NavigationLink' + index}
            link={link}
            isActive={link.links?.length > 0 && activeMegaMenuLink === link}
            onLinkHover={() => debouncedSetActiveMegaMenuLink(link)}
            onMouseLeaveLink={onMouseLeaveLink}
            onMegaMenuClose={onMegaMenuClose}
          />
        ))}
      </div>
      {!ecommerceDisabled && <MyAccountDesktopContainer />}
    </div>
  ) : null;
};

export default Navigation;
